import { render, staticRenderFns } from "./qcentriscountryAllocation.vue?vue&type=template&id=246f81a0&scoped=true&"
import script from "./qcentriscountryAllocation.vue?vue&type=script&lang=js&"
export * from "./qcentriscountryAllocation.vue?vue&type=script&lang=js&"
import style0 from "./qcentriscountryAllocation.vue?vue&type=style&index=0&id=246f81a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f81a0",
  null
  
)

export default component.exports